// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-7f50ed61] {\n  font-weight: 700;\n  margin: 0 0 var(--magic-space--small, 8px);\n}\n\n.text[data-v-7f50ed61] {\n  font-size: 0.88rem;\n}\n\n.item[data-v-7f50ed61] {\n  margin-bottom: var(--magic-space--xx-small, 2px);\n}", ""]);
// Exports
module.exports = exports;
